import { OrderType } from '../types';

export function isNil(value: unknown): value is null | undefined {
  return value === null || value === undefined;
}

export function isVowel(char: string) {
  return ['a', 'e', 'i', 'o', 'u'].indexOf(char.toLowerCase()) !== -1;
}

export function capitalize(word: string) {
  return word.at(0)?.toUpperCase() + word.slice(1);
}

export function fromEnumToReadableString(name: string) {
  return name.toLowerCase().split('_').map(capitalize).join(' ');
}

export const pluralize = (string: string) => {
  if (string.at(-1) === 'y') {
    return `${string.slice(0, -1)}ies`;
  }
  return string + 's';
};

function descendingComparator<T>(a: T, b: T, orderBy: keyof T) {
  if (b[orderBy] < a[orderBy]) {
    return -1;
  }
  if (b[orderBy] > a[orderBy]) {
    return 1;
  }
  return 0;
}

export function getComparator<Entity>(order: OrderType, orderBy: keyof Entity) {
  return order === 'desc'
    ? (a: Entity, b: Entity) => descendingComparator(a, b, orderBy)
    : (a: Entity, b: Entity) => -descendingComparator(a, b, orderBy);
}
